
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningUnacknowledgedOutlined as ObiWarningUnacknowledgedOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-unacknowledged-outlined.js';
 
 
 

 
 export const ObiWarningUnacknowledgedOutlined = createComponent({
   react: React,
   tagName: 'obi-warning-unacknowledged-outlined',
   elementClass: ObiWarningUnacknowledgedOutlinedElement,
   events: {
     
   }
  });
 
 